<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>用户权限查询</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchqx"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="Lookqx"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="100px" :model="queryInfo" size="small">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户编号">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.empCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户姓名">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.empName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="角色描述">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.roleName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select style="width: 50%" v-model="queryInfo.state">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="有效" value="0"></el-option>
                  <el-option label="无效" value="1  "></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 50%"
                  v-model="queryInfo.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div>
      <!-- 首页列表内容 -->
      <el-card shadow="never" class="centercard">
        <el-table
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 29.3rem)' : 'calc(100vh - 27rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="ActionroleqxList"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radio"
                @change="ActionroleqxRadioChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="empCode" label="用户编号"> </el-table-column>
          <el-table-column prop="empName" label="姓名"> </el-table-column>
          <el-table-column prop="shopCode" label="门店"> </el-table-column>
          <el-table-column
            prop="roleNameList"
            label="操作权限"
          ></el-table-column>
          <el-table-column prop="dataRole.roleName" label="数据权限">
          </el-table-column>
          <el-table-column prop="state" label="用户状态">
            <template slot-scope="scope">
              {{ scope.row.state === 0 ? "有效" : "无效" }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 查看弹窗 -->
    <div class="found">
      <el-dialog
        width="30%"
        title="用户角色查询-查看"
        :visible.sync="foundVisible"
        :close-on-click-modal="false"
        @close="SeeQxlbClose"
      >
        <div>
          <el-form
            size="mini"
            label-width="100px"
            :model="lookqxForm"
            ref="lookqxFormRef"
          >
            <el-row>
              <el-col :span="20">
                <el-form-item label="用户编号" prop="empCode">
                  <el-input
                    disabled
                    style="width: 95%"
                    v-model="lookqxForm.empCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="姓名" prop="empName">
                  <el-input
                    disabled
                    style="width: 95%"
                    v-model="lookqxForm.empName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="门店" prop="shopCode">
                  <el-input
                    disabled
                    style="width: 95%"
                    v-model="lookqxForm.shopCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="门店名称" prop="shopName">
                  <el-input
                    disabled
                    style="width: 95%"
                    v-model="lookqxForm.shopName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="数据权限" prop="roleName">
                  <el-input
                    disabled
                    style="width: 95%"
                    v-model="lookqxForm.dataRole.roleName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="20">
                <el-form-item label="操作权限">
                  <el-table
                    style="width: 98%"
                    height="150px"
                    size="small"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                      fontSize: '14px',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="lookqxForm.oprRoles"
                    tooltip-effect="dark"
                  >
                    <el-table-column type="index" width="45"> </el-table-column>
                    <el-table-column prop="roleCode" label="用户编号">
                    </el-table-column>
                    <el-table-column prop="roleName" label="用户描述">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Detailed">详细功能权限</el-button>
          <el-button @click="foundVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 用户角色查询 ---详细功能 -->
    <div class="found">
      <el-dialog
        width="30%"
        title="角色功能汇总查看"
        :visible.sync="DetailedFormvisible"
        :close-on-click-modal="false"
        @close="DetailedClosed"
      >
        <div class="menutitle">
          <span class="titlewz">菜单功能</span>
        </div>
        <el-row>
          <el-col>
            <el-tree
              :data="treecontrol"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="tree"
              highlight-current
              :default-checked-keys="qxxuanzhong"
              :props="defaultProps"
            >
            </el-tree>
          </el-col>
        </el-row>

        <div slot="footer" class="dialog-footer">
          <el-button @click="DetailedFormvisible = false">返 回</el-button>
          <el-button @click="qxquxiao">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  SysempRolepageApi,
  SysempRolequeryApi,
  SysempRolequerylimitsqxApi,
} from "@/api/user";
import { dateTimes } from "@/utils/auth";
export default {
  name: "alterations",
  data() {
    return {
      jurisdiction: {
        search: false,
        look: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 查看弹窗
      foundVisible: false,
      // 详细功能弹窗
      DetailedFormvisible: false,
      // 首页radio
      radio: "",
      // 首页radio选中获取数据
      radioValuesjList: [],
      // // 首页搜索请求参数
      // searchqxlist: {
      //   empID: "",
      //   empName: "",
      //   roleName: "",
      //   state: "",
      //   createTimeStart: "",
      //   createTimeEnd: "",
      //   pageNo: 1,
      //   pageSize: 50,
      // },
      // 首页列表内容
      ActionroleqxList: [],
      // 首页列表请求参数
      queryInfo: {
        empCode: "",
        empName: "",
        roleName: "",
        state: "",
        datePicker: "",
        createTimeStart: "",
        createTimeEnd: "",
        pageNo: 1, //页码
        pageSize: 50, //页数据
        pages: 0, //页总数据
      },
      // 首页loading
      loading: false,
      // 查看弹窗表单
      lookqxForm: {
        dataRole: {
          roleName: "",
        },
      },
      // 查看请求参数
      lookqxFormcs: {
        empID: "",
      },
      oprRolesList: [],
      // 详细功能弹窗请求参数
      Detailedcs: {
        empID: "",
      },
      // 详细功能弹窗树形列表
      treecontrol: [],
      defaultProps: {
        disabled: this.disabledFnqx,
        children: "children",
        label: "menuName",
      },
      qxxuanzhong: [],
      expandedKeys: [],
    };
  },
  created() {
    this.SysempRolepageList();
    let PermissionQuery = JSON.parse(localStorage.getItem("PermissionQuery"));
    for (let i = 0; i < PermissionQuery.length; i++) {
      if (PermissionQuery[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (PermissionQuery[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(PermissionQuery);
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    // 首页radio选中获取数据
    ActionroleqxRadioChange(value) {
      this.radioValuesjList = value;
    },
    // 首页列表查询
    async searchqx() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createTimeStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createTimeEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      }
      this.queryInfo.pageNo = 1;
      this.queryInfo.pageSize = 50;
      let data = {
        empCode: this.queryInfo.empCode,
        empName: this.queryInfo.empName,
        roleName: this.queryInfo.roleName,
        state: this.queryInfo.state,
        createTimeStart: this.queryInfo.createTimeStart,
        createTimeEnd: this.queryInfo.createTimeEnd,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysempRolepageApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询角色失败!");
          return;
        } else {
          if (res.success) {
            res.data.list.forEach((item) => {
              item.roleNameList = "";
              item.oprRoles.forEach((item1) => {
                item.roleNameList += item1.roleName + ",";
              });
              item.roleNameList = item.roleNameList.substring(
                0,
                item.roleNameList.length - 1
              );
            });
          }
          this.$message.success("查询角色成功!");
          this.ActionroleqxList = res.data.list;
          this.queryInfo.pages = res.data.pages;
        }
      });
    },
    // 首页列表
    async SysempRolepageList() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createTimeStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createTimeEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createTimeStart = "";
        this.queryInfo.createTimeEnd = "";
      }
      let data = {
        empCode: this.queryInfo.empCode,
        empName: this.queryInfo.empName,
        roleName: this.queryInfo.roleName,
        state: this.queryInfo.state,
        createTimeStart: this.queryInfo.createTimeStart,
        createTimeEnd: this.queryInfo.createTimeEnd,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysempRolepageApi(data).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.roleNameList = "";
            item.oprRoles.forEach((item1) => {
              item.roleNameList += item1.roleName + ",";
            });
            item.roleNameList = item.roleNameList.substring(
              0,
              item.roleNameList.length - 1
            );
          });
        }
        if (this.queryInfo.pageNo == 1) this.ActionroleqxList = [];
        this.ActionroleqxList = this.ActionroleqxList.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      // 滑倒底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.SysempRolepageList();
      });
    },
    // 查看按钮事件
    Lookqx() {
      if (this.radioValuesjList.length == 0) {
        this.$message.warning("请选择单条数据,进行查看!");
      } else {
        // 获取id
        this.lookqxid();
        // 发送请求查看记录
        SysempRolequeryApi(this.lookqxFormcs).then((res) => {
          if (res.data.dataRole == null) {
            res.data.dataRole = {};
          }
          // let i=0
          // Object.keys(res.data).forEach((item) =>{
          //   console.log(item != 'dataRole');
          //   if(item!='dataRole'){
          //         i+=1
          //   }
          //   console.log(item)
          // })
          // if(Object.keys(res.data).length==i){
          //     res.data.dataRole={}
          // }
          // console.log(Object.keys(res.data).length)
          // console.log(i)
          // console.log(res.data)
          this.lookqxForm = res.data;
          this.Detailedcs.empID = res.data.empID;
          if (res.success !== true) {
            this.$message.error("查看角色定义失败!");
            return;
          }
          this.$message.success("查看角色定义成功!");
        });
        // 打开查看弹窗
        this.foundVisible = true;
      }
    },
    // 获取id事件
    lookqxid() {
      this.lookqxFormcs.empID = this.radioValuesjList.empID;
    },
    // 监听查看弹窗的关闭事件
    SeeQxlbClose() {
      this.$refs.lookqxFormRef.resetFields();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 详细功能树节点列表
    Detailed() {
      SysempRolequerylimitsqxApi(this.Detailedcs).then((res) => {
        this.treecontrol = res.data;
        this.setName(this.treecontrol);
        if (res.success !== true) {
          this.$$message.error("角色功能汇总查看失败!");
          return;
        }
        this.$message.success("角色功能汇总查看成功");
      });
      this.DetailedFormvisible = true;
    },
    setName(treecontrol) {
      //遍历树  获取id数组
      for (var i in treecontrol) {
        // 如果checked不是true就不push ID
        if (treecontrol[i].checked == true)
          this.expandedKeys.push(treecontrol[i].id); // 遍历项目满足条件后的操作
        if (treecontrol[i].children) {
          //存在子节点就递归
          this.setName(treecontrol[i].children);
        }
      }
      this.qxxuanzhong = this.expandedKeys;
    },
    // 详细功能关闭事件
    DetailedClosed() {
      this.expandedKeys = [];
    },
    // 详细功能tree为禁用
    disabledFnqx() {
      return true;
    },
    //
    qxquxiao() {
      this.DetailedFormvisible = false;
      this.foundVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
// #alterations {
//   height: 100%;
// }
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 创建弹窗样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 详细功能弹窗标题栏
  .menutitle {
    height: 40px;
    // border: 1px solid #000;
    background-color: #f3f1dd;
    position: relative;
  }
  .titlewz {
    position: absolute;
    top: 50%;
    transform: translate(10%, -50%);
    font-size: 0.875rem;
    color: #6c6937;
  }
}
</style>
